import { __makeTemplateObject, __assign, __spreadArray } from '../../node_modules/tslib/tslib.es6.js';
import React, { useRef, useEffect } from 'react';
import { TextInputWithTokens, themeGet, Box, IssueLabelToken } from '@primer/react';
import styled from 'styled-components';

var EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var validateEmail = function validateEmail(email) {
  return email.match(EMAIL_REGEX);
};
var StyledTextInputWithTokens = styled(TextInputWithTokens)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & input::placeholder {\n    color: ", ";\n  }\n"], ["\n  & input::placeholder {\n    color: ", ";\n  }\n"])), themeGet("colors.fg.muted"));
/**
 * Component for adding email(s).
 * @param {string} boxWidth The width of the box.
 * @param {string} emailFillColor The color to be used for displaying email chip.
 * @param {function} onEmailAdd The callback to be invoked when email is preserved.
 * @param {boolean} size The size of the chip.
 */
var LTEmails = function LTEmails(_a) {
  var _b = _a.autoCompleteType,
    autoCompleteType = _b === void 0 ? undefined : _b,
    _c = _a.ariaRequired,
    ariaRequired = _c === void 0 ? false : _c,
    _d = _a.boxWidth,
    boxWidth = _d === void 0 ? "500px" : _d,
    _e = _a.emailFillColor,
    emailFillColor = _e === void 0 ? "#DDF4FF" : _e,
    _f = _a.onEmailAdd,
    onEmailAdd = _f === void 0 ? function () {} : _f,
    _g = _a.size,
    size = _g === void 0 ? LTEmails.Size.MEDIUM : _g,
    _h = _a.hasError,
    hasError = _h === void 0 ? "" : _h;
  var inputRef = useRef();
  var _j = React.useState([]),
    tokens = _j[0],
    setTokens = _j[1];
  var _k = React.useState(hasError),
    validationStatus = _k[0],
    setValidationStatus = _k[1];
  var onTokenRemove = function onTokenRemove(tokenId) {
    setTokens(tokens.filter(function (token) {
      return token.id !== tokenId;
    }));
  };
  var tokenComponent = function tokenComponent(props) {
    return /*#__PURE__*/React.createElement(IssueLabelToken, __assign({
      sx: {
        alignItems: "center",
        background: emailFillColor,
        color: "#0969DA",
        display: "flex",
        padding: "1px 8px",
        ":hover": {
          background: "#c5eafc"
        },
        "&:focus-visible": {
          outline: "1.5px solid #0b61cd !important"
        }
      }
    }, props));
  };
  var validateAndAddEmailToken = function validateAndAddEmailToken(inputValue, shouldValidateEmpty) {
    if (shouldValidateEmpty === void 0) {
      shouldValidateEmpty = true;
    }
    var email = inputValue.trim();
    if (!shouldValidateEmpty && !email) {
      return;
    }
    var isEmailValid = validateEmail(email);
    setValidationStatus(isEmailValid ? "" : "error");
    if (isEmailValid) {
      // Preserve newly added email ID.
      setTokens(__spreadArray(__spreadArray([], tokens, true), [{
        fillColor: emailFillColor,
        id: "".concat(inputValue, "-").concat(tokens.length),
        text: inputValue
      }], false));
      // Reset input.
      if (inputRef && inputRef.current) {
        inputRef.current.value = "";
      }
    }
  };
  var handleKeyDown = function handleKeyDown(event) {
    var inputValue = event.target.value;
    if (event.key === "Enter" || event.key === " ") {
      validateAndAddEmailToken(inputValue);
    }
    if (event.key === "Tab") {
      setValidationStatus(inputValue ? "error" : "");
    }
  };
  useEffect(function () {
    var emailsToSend = tokens.map(function (_a) {
      var text = _a.text;
      return text;
    });
    onEmailAdd(emailsToSend);
  }, [tokens]);
  useEffect(function () {
    setValidationStatus(hasError);
  }, [hasError]);
  return /*#__PURE__*/React.createElement(Box, {
    maxWidth: boxWidth,
    className: "textAreaWrapper",
    role: "group"
  }, /*#__PURE__*/React.createElement(StyledTextInputWithTokens, {
    "aria-required": ariaRequired,
    autoComplete: autoCompleteType,
    placeholder: "Enter email ID(s)",
    ref: inputRef,
    preventTokenWrapping: true,
    block: true,
    tokens: tokens,
    onKeyDown: handleKeyDown,
    tokenComponent: tokenComponent,
    onBlur: function onBlur() {
      return validateAndAddEmailToken(inputRef.current.value, false);
    },
    onTokenRemove: onTokenRemove,
    id: "lt-components-email-inputs-token",
    validationStatus: validationStatus,
    size: size,
    sx: {
      padding: "5px 8px",
      gap: "8px",
      borderRadius: "6px",
      background: "#f7f7f7"
    }
  }));
};
LTEmails.Size = {
  LARGE: "large",
  MEDIUM: "medium",
  SMALL: "small",
  XLARGE: "xlarge"
};
var templateObject_1;

export { LTEmails as default };
